export const getSizeSystemByCountryCode = (countryCode: string): string => {
  const countryCodeSizeSystemMap: Record<string, string> = {
    FR: "FR",
    ES: "FR",
    PT: "FR",
    IT: "IT",
    GB: "UK",
    IE: "UK",
    US: "US",
    CA: "US",
    AU: "AU",
    NZ: "AU",
  };

  return countryCodeSizeSystemMap[countryCode] ?? "EU";
};
